import React, { useRef } from 'react';
import { useI18n } from '../i18n/I18nProvider';

const LanguageSwitcher = () => {
  const { locale, setLocale, t } = useI18n();
  const detailsRef = useRef(null);
  const currentCode = locale.toUpperCase();

  const chooseLocale = (nextLocale) => {
    setLocale(nextLocale);
    if (detailsRef.current) {
      detailsRef.current.open = false;
    }
  };

  return (
    <details className="uh-lang-menu" ref={detailsRef}>
      <summary className="uh-lang-menu-trigger" aria-label={t('common.language')}>
        <span className="uh-lang-menu-value">{currentCode}</span>
      </summary>
      <div className="uh-lang-menu-panel" role="menu" aria-label={t('common.language')}>
        <button
          type="button"
          className={locale === 'en' ? 'uh-lang-menu-item active' : 'uh-lang-menu-item'}
          onClick={() => chooseLocale('en')}
          aria-label="English"
        >
          <span>EN</span>
        </button>
        <button
          type="button"
          className={locale === 'ru' ? 'uh-lang-menu-item active' : 'uh-lang-menu-item'}
          onClick={() => chooseLocale('ru')}
          aria-label="Русский"
        >
          <span>RU</span>
        </button>
      </div>
    </details>
  );
};

export default LanguageSwitcher;
